export default __webpack_public_path__ + "static/media/new_customer.4404dff7.png";